// Single source of truth for the "RABS Domain Workspace" design system
// (Blue · Light). These tokens mirror Section 2 of the build spec and the
// values that were previously copy-pasted across Dashboard, Sidebar, Header and
// FlatCard. Import from here instead of hardcoding hex values per page.
//
//   import { COLORS, RADIUS, SHADOW } from "../theme/tokens";
//
// NOTE: this is a light-only palette. Dark mode still lives in ThemeContext for
// the older pages, but all spec UI is built light-only and pulls from here.

// --- Colors -----------------------------------------------------------------
export const COLORS = {
  // Brand blue
  primary:      "#3B82F6", // oklch(62.3% .214 259.8)
  primarySoft:  "#EFF6FF", // active nav fill / soft chips
  primaryDark:  "#1D4ED8", // gradients, hover-dark

  // Ink + text
  ink:        "#0F172A", // headings / primary text
  muted:      "#64748B", // secondary text / icons
  faint:      "#94A3B8", // tertiary / placeholder / eyebrow

  // Surfaces
  canvas:   "#F4F6FB", // page background
  tile:     "#F8FAFC", // inner tiles / hover fill
  surface:  "#FFFFFF", // cards / panels

  // Hairlines / borders
  hairline:      "#EEF1F6",
  hairlineStrong:"#E2E8F0",
  borderHover:   "#DBE3EF",

  // Status — each with a soft (background) variant
  success:     "#16A34A",
  successSoft: "#DCFCE7",
  warning:     "#D97706",
  warningSoft: "#FEF3C7",
  danger:      "#DC2626",
  dangerSoft:  "#FEE2E2",
};

// --- Radius (px) ------------------------------------------------------------
export const RADIUS = {
  input: "10px", // inputs / buttons
  card:  "16px", // cards / modals
  chip:  "9px",  // icon chips
  pill:  "999px",// pills / avatars
};

// --- Shadows ----------------------------------------------------------------
export const SHADOW = {
  card:  "0 1px 3px rgba(16, 24, 40, 0.05)",       // resting content surfaces
  hover: "0 8px 24px rgba(16, 24, 40, 0.10)",      // hover-lifted cards
  modal: "0 24px 64px rgba(16, 24, 40, 0.18)",     // modals / drawers
};

// --- Motion -----------------------------------------------------------------
export const MOTION = {
  // Spec: entrance 180–260ms cubic-bezier(.16,1,.3,1); no bounces/loops.
  ease:     "cubic-bezier(0.16, 1, 0.3, 1)",
  duration: "0.22s",
  transition: "all 0.22s cubic-bezier(0.16, 1, 0.3, 1)",
};

// --- Typography sizes (px) --------------------------------------------------
// Font families live in theme/fonts.js (HEADING_FONT / BODY_FONT). These are
// the spec's size scale for consistent text across pages.
export const TEXT = {
  pageTitle:    20, // 20px / 700
  sectionTitle: 15, // 15–16px / 600
  body:         13.5,
  cell:         13.5,
  label:        12, // 12px / 600
  eyebrow:      10.5, // 10–11px / 700 uppercase tracked
};

const tokens = { COLORS, RADIUS, SHADOW, MOTION, TEXT };
export default tokens;
